export default __webpack_public_path__ + "static/media/banner-desk.cf56504a.webp";